module.exports = __webpack_public_path__ + "static/media/check.18fa83ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check.svg
// module id = 868
// module chunks = 0